import React from "react";
import { View, Text, StyleSheet } from "react-native";

export const SOURCE_COLORS = {
  google: "#1A73E8",
  disgo: "#D93025",
};

export function SourceAsterisk({ source }) {
  const color = SOURCE_COLORS[source] || SOURCE_COLORS.disgo;
  return (
    <Text style={[styles.asterisk, { color }]} accessibilityLabel={source === "google" ? "Google Places" : "Disgo database"}>
      *
    </Text>
  );
}

export function SourceLegend() {
  return (
    <View style={styles.legend}>
      <View style={styles.legendItem}>
        <Text style={[styles.legendAsterisk, { color: SOURCE_COLORS.google }]}>*</Text>
        <Text style={styles.legendText}>Google Places</Text>
      </View>
      <View style={styles.legendItem}>
        <Text style={[styles.legendAsterisk, { color: SOURCE_COLORS.disgo }]}>*</Text>
        <Text style={styles.legendText}>Disgo database</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  asterisk: {
    fontSize: 14,
    fontWeight: "700",
    lineHeight: 16,
  },
  legend: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
    marginTop: 16,
    paddingTop: 14,
    borderTopWidth: 1,
    borderTopColor: "#F0E8E1",
    alignSelf: "stretch",
    justifyContent: "center",
  },
  legendItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  legendAsterisk: {
    fontSize: 18,
    fontWeight: "700",
    lineHeight: 20,
  },
  legendText: {
    fontSize: 13,
    color: "#6B5A4E",
    fontWeight: "500",
  },
});
